"use strict";

exports.__esModule = true;
exports.useDelayUnmount = useDelayUnmount;
var _react = require("react");
/**
 * useDelayUnmount
 * Allow to add fade out effects for an unmounting component
 * From https://stackoverflow.com/a/54114180
 *
 * @param {boolean} isMounted
 * @param {number} delayTime
 * @returns
 *
 * @example
 * Source: https://codesandbox.io/s/lpn3261j99?file=/src/index.tsx:674-732
 *
 * const Parent = () => {
 *   const [ isMounted, setIsMounted ] = useState(true);
 *   const shouldRenderChild = useDelayUnmount(isMounted, 500);
 *   const mountedStyle = {opacity: 1, transition: "opacity 500ms ease-in"};
 *   const unmountedStyle = {opacity: 0, transition: "opacity 500ms ease-in"};
 *
 *   const handleToggleClicked = () => {
 *     setIsMounted(!isMounted);
 *   };
 *
 *   return (
 *     <>
 *       {shouldRenderChild && <Child style={isMounted ? mountedStyle : unmountedStyle} />}
 *       <button onClick={handleToggleClicked}>Click me!</button>
 *     </>
 *   );
 * }
 *
 */
function useDelayUnmount(isMounted, delayTime, cb) {
  if (cb === void 0) {
    cb = function cb() {
      return undefined;
    };
  }
  var _useState = (0, _react.useState)(false),
    shouldRender = _useState[0],
    setShouldRender = _useState[1];
  (0, _react.useEffect)(function () {
    var timeoutId;
    if (isMounted && !shouldRender) {
      setShouldRender(true);
    } else if (!isMounted && shouldRender) {
      timeoutId = setTimeout(function () {
        setShouldRender(false);
        cb();
      }, delayTime);
    }
    return function () {
      return clearTimeout(timeoutId);
    };
  }, [isMounted, delayTime, shouldRender]);
  return shouldRender;
}